import * as logger from 'loglevel';
import transformRequest from './transformRequest/transformSubscription';
import axiosWrapper from '../../helpers/axiosWrapper';
import { NO_DURATION_DEFINED } from '../../helpers/axiosWrapper/cache';
import { buildQuery } from './utils/utils';

const getSubscription = (filter, meta, integrationSettings, pageContext) => {
  return new Promise((resolve, reject) => {
    if (!integrationSettings) {
      const MESSAGE = `INTEGRATION__FARES: **integrationSettings** not specified.`;
      logger.error(MESSAGE);
      reject(MESSAGE);
    }
    const { v1CampaignMonitor } = integrationSettings;
    const { cache = false, cacheDuration = NO_DURATION_DEFINED } = v1CampaignMonitor;
    if (!v1CampaignMonitor || !v1CampaignMonitor.method || !v1CampaignMonitor.endPoint) {
      const MESSAGE = `INTEGRATION__FARES: **integrationSettings.v1CampaignMonitor** configuration issues.`;
      logger.error(MESSAGE);
      reject(MESSAGE);
    }
    const filterCopy = { ...filter };
    const params = buildQuery(filterCopy, false);
    axiosWrapper(
      {
        method: v1CampaignMonitor.method,
        url: v1CampaignMonitor.endPoint,
        headers: { ...v1CampaignMonitor.headers },
        data: transformRequest(params)
      },
      {
        resource: 'INTEGRATION__CAMPAIGN_MONITOR_ADD_SUBSCRIBER',
        meta,
        integrationSettings,
        pageContext,
        cache,
        cacheDuration
      }
    )
      .then(({ data }) => {
        if (data.success) {
          logger.info('SUBSCRIPTION__CAMPAIGN_MONITOR: USER ADDED', data);
          resolve(data);
        } else {
          logger.error('SUBSCRIPTION__CAMPAIGN_MONITOR: Successful request', data);
          reject(data);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export { getSubscription };
